import type { HttpClient } from '@wix/http-client'
import type {
  SitemapCountRequestBody,
  DynamicPageRouterData,
  GridAppId,
} from '@wix/wix-data-client-common-standalone'
import type { ResponseData } from './types'

type SitemapCountRequest = {
  config: Record<string, string>
  fullUrl: string
  pageRoles: Record<string, { id: string; title: string }>
  requestInfo: object
  routerPrefix: string
  routerSuffix: string
}

export interface SitemapCountApi {
  fetchRoutersPatternCounts: (
    routers: DynamicPageRouterData[],
  ) => Promise<ResponseData[]>
}

const createSitemapRequestBody = (
  router: DynamicPageRouterData,
): SitemapCountRequestBody => {
  const requestBody: SitemapCountRequestBody = {
    config: router.config,
    pageRoles: router.pages.reduce(
      (pageRoles, pages) => ({
        ...pageRoles,
        [pages.pageRoles[0]]: { id: pages.pageRef.id, title: '' },
      }),
      {} as SitemapCountRequest['pageRoles'],
    ),
    routerPrefix: `/${router.prefix}`,
    routerSuffix: '/',
    requestInfo: {},
    fullUrl: `/${router.prefix}/`,
  }
  return requestBody
}

export const createSitemapCountApi = (
  httpClient: HttpClient,
  getGridAppId: () => Promise<GridAppId | undefined>,
): SitemapCountApi => ({
  fetchRoutersPatternCounts: async (routers: DynamicPageRouterData[]) => {
    const gridAppId = await getGridAppId()

    return Promise.all(
      routers.map(async router => {
        const requestData = createSitemapRequestBody(router)

        const params = new URLSearchParams({
          viewMode: 'editor',
        })
        if (gridAppId) {
          params.append('gridAppId', gridAppId)
        }
        const query = params.toString()

        const response = await httpClient.post<ResponseData>(
          `/_api/dynamic-pages-router/v1/sitemapCount?${query}`,
          requestData,
        )

        return response.data
      }),
    )
  },
})
